module.exports = __webpack_public_path__ + "img/img63.42d566f6.png";